import { defBaseUnit, defSimpleUnit } from '../registry';

export const informationUnits = [
  defBaseUnit('bit'),

  defSimpleUnit('kilobit', 'bit', 1e3),
  defSimpleUnit('megabit', 'bit', 1e6),
  defSimpleUnit('gigabit', 'bit', 1e9),
  defSimpleUnit('terabit', 'bit', 1e12),
  defSimpleUnit('petabit', 'bit', 1e15),
  defSimpleUnit('exabit', 'bit', 1e18),
  defSimpleUnit('zettabit', 'bit', 1e21),
  defSimpleUnit('yottabit', 'bit', 1e24),

  defSimpleUnit('kibibit', 'bit', Math.pow(2, 10)),
  defSimpleUnit('mebibit', 'bit', Math.pow(2, 20)),
  defSimpleUnit('gibibit', 'bit', Math.pow(2, 30)),
  defSimpleUnit('tebibit', 'bit', Math.pow(2, 40)),
  defSimpleUnit('pebibit', 'bit', Math.pow(2, 50)),
  defSimpleUnit('exbibit', 'bit', Math.pow(2, 60)),
  defSimpleUnit('zebibit', 'bit', Math.pow(2, 70)),
  defSimpleUnit('yobibit', 'bit', Math.pow(2, 80)),

  defSimpleUnit('byte', 'bit', 8),

  defSimpleUnit('kibibyte', 'bit', Math.pow(2, 13)),
  defSimpleUnit('mebibyte', 'bit', Math.pow(2, 23)),
  defSimpleUnit('gibibyte', 'bit', Math.pow(2, 33)),
  defSimpleUnit('tebibyte', 'bit', Math.pow(2, 43)),
  defSimpleUnit('pebibyte', 'bit', Math.pow(2, 53)),
  defSimpleUnit('exbibyte', 'bit', Math.pow(2, 63)),
  defSimpleUnit('zebibyte', 'bit', Math.pow(2, 73)),
  defSimpleUnit('yobibyte', 'bit', Math.pow(2, 83)),

  defSimpleUnit('kilobyte', 'bit', 8e3),
  defSimpleUnit('megabyte', 'bit', 8e6),
  defSimpleUnit('gigabyte', 'bit', 8e9),
  defSimpleUnit('terabyte', 'bit', 8e12),
  defSimpleUnit('petabyte', 'bit', 8e15),
  defSimpleUnit('exabyte', 'bit', 8e18),
  defSimpleUnit('zettabyte', 'bit', 8e21),
  defSimpleUnit('yottabyte', 'bit', 8e24),
];

// NOT defining any aliases for now, because they are dangerously ambiguous.
